import DateRangePicker from "components/DateRangePicker";
import { useFilterActions } from "../../ducks/filter/hooks/actions";
import { useFilterState } from "../../ducks/filter/hooks/filterState";
import { DateRange } from "react-day-picker";

export function DateRangeHeader() {
  const { updateFilter } = useFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const handleDateRangeChange = (range: DateRange | undefined) => {
    updateFilter({ key: "dateRange", value: range });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const currentDateRange = filters.dateRange;

  return (
    <DateRangePicker
      date={currentDateRange}
      onDateChange={handleDateRangeChange}
      className="h-10"
    />
  );
}
